
// COLLECTION メニューマウスホバー時のイベント
// メニューが上からドロップダウンし、ヘッダーの背景色が白&背景がぼやける

$(function(){
    $('#is_site-nav--has-doropdown').hover(function(){
        $('#SiteNavLabel-collection').stop().slideToggle(200);
        $('.site-header').stop().toggleClass('hoverMenu-dropdown');
    });
});

$(function(){
    $('.site--nav-hasNodropdown').hover(function(){
        $('.site-header').stop().toggleClass('hoverMenu');
    });
});


// SIZE GUIDE ハイライトのアニメーション
$(function(){
    $(".guide_td").hover(function(){
        $(this).parent().addClass("guide_target");

        var myIndex = $(this).index();

        myIndex ++;

        $(".guide_td:nth-child("+ myIndex +")").addClass("guide_target");
    },function(){
        $(".guide_target").removeClass("guide_target");
    });
});



//商品ページ 、セレクトエリアの高さ及びサイズガイドモーダルの幅調整
//商品ページ サイズガイド表のスライドイン
$(document).ready(function() {
    console.log('my-script.js');

    function adjustSizes() {
        var Height = $('.product-picture__main--img').height();
        var headerHeight = $('.site-header').height();
        if (window.matchMedia('(min-width: 1023px)').matches) {
            $('.product-size__modal-container').height(Height + headerHeight);
        } else if(window.matchMedia('(max-width: 1022px)').matches){
            $('.product-size__modal-container').css('height', 100 + "vh");
        }
        var Width = $('.product-desc__container').width();
        $('.product-size__modal-container').width(Width);
    }

    var Width = $('.product-desc__block').width();
    $('.product-size__modal-container').css('transform','translateX(' + Width + 'px)');
    $('#measurement-activeBtn').click(function(){
        $('.template-common').addClass('is-sideGuideOpen');
        $('#js-product-size').attr("area-hidden" , "false");
        $('.product-size__modal-container').css(
            {
                visibility: 'visible',
                transform: 'translateX(0px)',
                transition: '0.3s'
            }
            );
        return false;
    });
    $('#js-closeBtn').click(function(){
        $('.template-common').removeClass('is-sideGuideOpen');
        $('#js-product-size').attr("area-hidden" , "true");
        $('.product-size__modal-container').css(
            {
                visibility: 'hidden',
                transform: 'translateX(' + Width + 'px)',
                transition: '0.3s'
            }
            );
        return false;
    });

    // 初回ページ読み込み時に実行
    adjustSizes();
    // 画面のリサイズ時に実行
    $(window).on('resize', function() {
        adjustSizes();
    });

    $('#main-slide-carousel').slick({
        dots: false,
        arrows: false, 
        autoplay: true,
        infinite: true,
        speed: 1500,
        fade: true,
        cssEase: 'linear'
    });
});


//サイズ表のトップ位置調整（<1023pxのとき、常にウィンドウのトップに表示）

$(document).ready(function() {
    function updatePosition() {
        var top = $(window).scrollTop();

        if (window.matchMedia('(max-width: 1022px)').matches && window.matchMedia('(min-width: 750px)').matches) {
            $('.product-size__modal-container').css('top', top + "px");
        } else if (window.matchMedia('(max-width: 749px)').matches) {
            $('.product-size__modal-container').css('top', top + "px");
        } else if (window.matchMedia('(min-width: 1023px)').matches) {
            $('.product-size__modal-container').css('top', 0);
        }
    }

    // 初回ページ読み込み時に実行
    updatePosition();

    // 画面のスクロール時にコードを実行
    $(window).scroll(function() {
        updatePosition();
    });

    // 画面のリサイズ時にコードを実行
    $(window).on('resize', function() {
        updatePosition();
    });
});

//商品ページ main pictureのスライダー
//Zoomボタンで拡大画像表示の処理

$(document).ready(function() {
    const swiper = new Swiper(".swiper", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
    });

    function updateModal() {
        var currentSlide = swiper.slides[swiper.activeIndex];
        var currentImageSrc = $(currentSlide).find('img').attr('src');
        $('#modal-image').attr('src', currentImageSrc);
        $('#swiper-modal').fadeIn();

        var modalWidth = $('#swiper-modal').width();
        var modal_picWidth = $('#modal-image').width();
        var CloseMargin = 10 + (modalWidth  - modal_picWidth) / 2;
        $('.modal-close').css('margin-right', CloseMargin + "px");
    }

    function closeModal() {
        $('#swiper-modal').fadeOut();
    }

    // ズームリンクがクリックされたときの処理
    $('.zoom-link').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        updateModal();
        return false;
    });

    // モーダルのクローズボタンがクリックされたときの処理
    $('.modal-close').click(function() {
        closeModal();
        return false;
    });

    // 画面のリサイズ時にコードを実行
    $(window).on('resize', function() {
        // 画面リサイズ時の処理をここに記述
    });
});



//商品画像登録数が１つの場合の
//Zoomボタンで拡大画像表示の処理
$(document).ready(function() {
    $('.zoom-link--singlePicture').click(function(e) {
    e.preventDefault();
    var imageSrc = $('.product-picture__main--img').attr('src');
    $('#modal-image').attr('src', imageSrc);
    $('#swiper-modal').fadeIn();

    var modalWidth =$('#swiper-modal').width();
    var modal_picWidth =$('#modal-image').width();
    var CloseMargin = 10 + (modalWidth  - modal_picWidth ) / 2;
    $('.modal-close').css('margin-right', CloseMargin + "px");

    return false;
    });
    $('.modal-close').click(function() {
    $('#swiper-modal').fadeOut();
    return false;
    });
});

//商品ページ 数量セレクターの増減設定
const $wrap = document.querySelector('.number-spinner-wrap')
const $input = $wrap.querySelector('input')

    $wrap.querySelector('.spinner-down').onclick = ()=>{
    $input.stepDown()
    }
    $wrap.querySelector('.spinner-up').onclick = ()=>{
    $input.stepUp()
    }

//商品ページ サイズガイド単位切り替え（cm inch）
$(function(){
    $('.sizeGuide-contents table[id != "size-guide__cm"]').hide();
    $('.unit-select').click(function(){
        $('.sizeGuide-contents table').hide();
        $($(this).attr("href")).show();
         $('.current-select').removeClass('current-select');
        $(this).addClass('current-select');

        return false;
    });
});


//商品ページ SHOP MOREのフェードインアニメーション
// https://coco-factory.jp/ugokuweb/move02/4-1/

$(function(){
    function fadeAnime(){
        //ふわっと動くきっかけのクラス名と動きのクラス名の設定
        $('.fadeUpTrigger').each(function(){ //fadeInUpTriggerというクラス名が
        var elemPos = $(this).offset().top - 50; //要素より、50px上の
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
        $(this).addClass('fadeUp');
        // 画面内に入ったらfadeUPというクラス名を追記
        }else{
        $(this).removeClass('fadeUp');
        // 画面外に出たらfadefadeUPというクラス名を外す
        }
        });
    }

    // 画面をスクロールをしたら動かしたい場合の記述
    $(window).scroll(function (){
        fadeAnime();/* アニメーション用の関数を呼ぶ*/
    });// ここまで画面をスクロールをしたら動かしたい場合の記述
});




  $(window).on('load',function(){

    const spinner = document.getElementById('loading-wrapper');
    spinner.classList.add('loaded');

  });

//商品バリエーションセレクトボックスの装飾（デフォルトのスタイル解除）
//参考サイト：https://techmemo.biz/javascript/jquery-select-text-center/
$(function(){
    $('.single-option-selector-1').change(function () {
        var select_option = $(this).find('option:selected');
        $(this).next('.size_select_label').text(select_option.text());
        $(this).blur(); //フォーカスを外す
      });

      $('.single-option-selector-2').change(function () {
        var select_option = $(this).find('option:selected');
        $(this).next('.size_select_label').text(select_option.text());
        $(this).blur(); //フォーカスを外す
      });

});

//SHOP MORE 商品画像ホバー時に2番目の画像
$(function(){
    $('.media--hover-effect').hover(function(){
        $(this).find('.sub-featured--image').css('opacity', 1); // 透明度を1にしてフェードイン
    },function(){
        $(this).find('.sub-featured--image').css('opacity', 0);
    });
    return false;
});




//商品画像Zoomボタンおよびスライダーの矢印の位置

$(document).ready(function() {
    function updateLayout() {
        var picWidth = $('.product-picture--width').width();
        var product_imgWidth = $('.product-picture__main--img').width();
        var zoomMargin = 10 + (picWidth - product_imgWidth) / 2;
        var ArrowMargin = 30 + (picWidth - product_imgWidth) / 2;
        var ArrowMarginSp = 10 + (picWidth - product_imgWidth) / 2;

        $('.zoom-btn').css('margin-right', zoomMargin + "px");

        if (window.matchMedia('(max-width: 750px)').matches) {
            $('.swiper-button-next').css('margin-right', ArrowMarginSp + "px");
            $('.swiper-button-prev').css('margin-left', ArrowMarginSp + "px");
        } else {
            $('.swiper-button-next').css('margin-right', ArrowMargin + "px");
            $('.swiper-button-prev').css('margin-left', ArrowMargin + "px");
        }
    }

    // 初回ページ読み込み時に実行
    updateLayout();

    // 画面のリサイズ時にコードを実行
    $(window).on('resize', function() {
        updateLayout();
    });
});



$(document).ready(function() {
    $('.custom-scrollbar').css('scrollbar-color', 'white transparent');
  });








